// loading.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private activeRequests = 0;
  private loadingDelayMs = 1000; // Delay in ms before emitting 'false'
  private hideTimeout: any = null;

  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      // Cancel any pending hide
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
      if (this.activeRequests === 0) {
        // Delay emitting 'false' to prevent flicker
        this.hideTimeout = setTimeout(() => {
          // Only emit if no new requests started during the delay
          if (this.activeRequests === 0) {
            this.loadingSubject.next(false);
          }
          this.hideTimeout = null;
        }, this.loadingDelayMs);
      }
    }
  }
}
